import Vue from 'vue'
import App from './App.vue'

import './permission'

import router from './router'
import store from './store'
import config from '@/config'
import area from '@/area'
import RequestService from '@/utils/service'

import { Tab, Tabs, Field, Button, Overlay, Toast, Loading, Popup, Picker, Slider, Icon } from 'vant'

Toast.setDefaultOptions({ duration: 3000 })

Vue.prototype.$store = store
Vue.prototype.config = config
Vue.prototype.area = area
Vue.prototype.toast = Toast
Vue.prototype.request = RequestService

Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Field)
Vue.use(Button)
Vue.use(Overlay)
Vue.use(Loading)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Slider)
Vue.use(Icon)

import * as filters from './filters'

Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

Vue.config.productionTip = false

import vconsole from 'vconsole'
if (area.id === 'dev') {
  new vconsole()
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
